const getSubdomain = (url = window.location.href) => {
  try {
    const hostname = new URL(url).hostname;
    const delen = hostname.split('.');

    // We willen het element op index (Lengte - 3)
    const index = delen.length - 3;

    // Zorg ervoor dat de array groot genoeg is en de index positief is.
    if (index >= 0) {
      return delen[index];
    }
    return null; // Te weinig delen (bijv. 'bar.nl')
  } catch (e) {
    // eslint-disable-next-line no-console
    console.warn('Ongeldige URL:', e);
    return null;
  }
};
export default getSubdomain;
